// Centralized asset URLs from the brand visual identity
export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_design-showcase-1404/artifacts/0jtvr5uk_Firefly.png";

// Transparent-background variants of the brand mark (color-keyed from original)
export const LOGO_LOCKUP_URL = "/logo_transparent.png";
export const LOGO_ICON_URL = "/logo_icon.png";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1663811397207-418a92396ad5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbiUyMGxpdmluZyUyMHJvb218ZW58MHx8fGJsYWNrfDE3ODMxNTcxODd8MA&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.unsplash.com/photo-1702865071692-71c7dd801b79?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbiUyMGxpdmluZyUyMHJvb218ZW58MHx8fGJsYWNrfDE3ODMxNTcxODd8MA&ixlib=rb-4.1.0&q=85",
  exterior:
    "https://images.unsplash.com/photo-1564343128896-3ffbcf9439e5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBsdXh1cnklMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8YmxhY2t8MTc4MzE1NzE4N3ww&ixlib=rb-4.1.0&q=85",
  global:
    "https://images.unsplash.com/photo-1610588043465-2551b34dffc7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBleHRlcmlvciUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8YmxhY2t8MTc4MzE1NzE4N3ww&ixlib=rb-4.1.0&q=85",
  texture:
    "https://images.unsplash.com/photo-1650876012351-234fb2685fb6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBhYnN0cmFjdCUyMGdvbGQlMjB0ZXh0dXJlfGVufDB8fHxibGFja3wxNzgzMTU3MTg3fDA&ixlib=rb-4.1.0&q=85",
  testimonial:
    "https://images.unsplash.com/photo-1652206758914-e888d5433545?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBhYnN0cmFjdCUyMGdvbGQlMjB0ZXh0dXJlfGVufDB8fHxibGFja3wxNzgzMTU3MTg3fDA&ixlib=rb-4.1.0&q=85",
};

// "L'Art de la Forteresse" — visuals rooted in Luxembourg's heritage
export const PHILOSOPHY = {
  ambiance:
    "https://static.prod-images.emergentagent.com/jobs/c3a46e92-acb2-4828-88aa-f614f3d12c09/images/de9bd2cf98c59e620218b49d7905f16ff7897003fc2fa6a31cc1ca94f514128e.png",
  pillars: [
    "https://static.prod-images.emergentagent.com/jobs/c3a46e92-acb2-4828-88aa-f614f3d12c09/images/f7498b529fe8f16a80935df717626cfa0d3c6a93f6b28736935a6c7a9726689b.png",
    "https://static.prod-images.emergentagent.com/jobs/c3a46e92-acb2-4828-88aa-f614f3d12c09/images/4b9b288cf383d25b61891aa303997499fa24cd77ead68103f6a0a4123dc516c5.png",
    "https://static.prod-images.emergentagent.com/jobs/c3a46e92-acb2-4828-88aa-f614f3d12c09/images/d68ff38ff3790c429cefaa809921f81c6a1154d3c57d504edb69b80c6c0912b5.png",
  ],
};
